import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { AdmihairBaseComponent } from '../../admihair-base.component';
import { ClienteService } from 'src/app/admihair/service/cliente.service';
import { AnamneseService } from 'src/app/admihair/service/anamnese.service';
import { ItemServicoService } from 'src/app/admihair/service/item-servico.service';
import { ItemProdutoService } from 'src/app/admihair/service/item-produto.service';
import { MensagemClienteService } from 'src/app/admihair/service/mensagem-cliente.service';
import { DiagnosticoClienteService } from 'src/app/admihair/service/diagnostico-cliente.service';
import { ProcessoClienteService } from 'src/app/admihair/service/processo-cliente.service';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { ErroService } from 'src/app/admihair/service/erro.service';
import { UtilStorageService } from 'src/app/admihair/service/util-storage.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Cliente } from 'src/app/admihair/api/dto/cliente';
import { DiagnosticoCliente } from 'src/app/admihair/api/dto/diagnostico-cliente';
import { Anamnese } from 'src/app/admihair/api/dto/anamnese';
import { FichaDiagnosticoCliente } from 'src/app/admihair/api/dto/ficha-diagnostico-cliente';
import { MensagemCliente } from 'src/app/admihair/api/dto/mensagem-cliente';
import { HistoricoCliente } from 'src/app/admihair/api/dto/historico-cliente';
import { ProcessoCliente } from 'src/app/admihair/api/dto/processo-cliente';
import { ItemProduto } from 'src/app/admihair/api/dto/item-produto';
import { ItemServico } from 'src/app/admihair/api/dto/item-servico';
import { Paginador } from 'src/app/admihair/api/dto/paginacao/paginador';
import { ContatoClienteService } from 'src/app/admihair/service/contato-cliente.service';
import { ContatoCliente } from 'src/app/admihair/api/dto/contato-cliente';

@Component({
  selector: 'app-cliente-ficha-resumo-janela',
  templateUrl: './cliente-ficha-resumo-janela.component.html',
  styleUrls: ['./cliente-ficha-resumo-janela.component.scss']
})
export class ClienteFichaResumoJanelaComponent extends AdmihairBaseComponent implements OnInit {

    id?: number;
    cliente?: Cliente;
    @ViewChild('filter') filter!: ElementRef;
    contatosClientes: ContatoCliente[] = [];
    
    listaDiagnosticosCliente: DiagnosticoCliente[] = [];
    loadingDiagnosticos: boolean = false;
    loadingAvaliacao: boolean = false;
    exibirDialogAvaliacao: boolean = false;
    valorLgpdAvaliacao: boolean = false;
  
    loadingAnamnese: boolean = false;
    listaAnamnese: Anamnese[] = [];
    listaFichaDiagnosticoCliente: FichaDiagnosticoCliente[] = [];
    anamneseSelecionada?: Anamnese;
    bloquearCheckLgpd: boolean = false;
    modoEditarAvaliacao: boolean = false;
    diagnosticoCliente: DiagnosticoCliente = {};
  
    listaRecados: MensagemCliente[] = [];
    listaRecadosInicial: MensagemCliente[] = [];
    exibirDialogRecado: boolean = false;
    loadingRecado: boolean = false;
    tiposMensagemCliente: string[] = ['DO CLIENTE', 'PARA O CLIENTE'];
    tipoMensagemSelecionada?: string;
    modoEditarRecado: boolean = false;
    recadoCliente: MensagemCliente = {};
    bloquearRdStatus: boolean = false;
    bloquearCheckCiencia: boolean = false;
    buscaRecado: string = '';
  
    loadingAlterarCiencia: boolean = false;
  
    listaHistoricoCliente: HistoricoCliente[] = [];
    listaHistoricoClienteInicial: HistoricoCliente[] = [];
    buscaHistorico: string = '';


  constructor(private clienteService: ClienteService,
      private contatoClienteService: ContatoClienteService,
      private anamneseService: AnamneseService,
      private mensagemClienteService: MensagemClienteService,
      private diagnosticoClienteService: DiagnosticoClienteService,
      private confirmationService: ConfirmationService,
      erroService: ErroService,
      storageService: UtilStorageService,
      router: Router,
      activatedRoute: ActivatedRoute) {
        super(erroService, storageService, router, activatedRoute)
       }

  ngOnInit(): void {
      this.carregarIdUrl();
      this.buscarCliente();
    }
  
    buscar() {
      console.log('teste')
    }
  
    buscarCliente() {
      this.clienteService.buscarPorId(this.idParametroUrl).subscribe({
        next: (data: Cliente) => {
          this.cliente = data;
          this.listarContatos();
          this.verificarAniversarioCliente();
        },
        error: (err: any) => {
          this.exibirMensagemErro(err);
        }
      });
    }

    listarContatos() {
        this.contatoClienteService.listarPorClienteId(this.cliente?.id).subscribe({
          next: (data: ContatoCliente[]) => {
            this.contatosClientes = data;
            this.listarDiagnosticos();
          },
          error: (err: any) => {
            this.exibirMensagemErro(err);
          }
        })
      }
  
    listarDiagnosticos() {
      this.diagnosticoClienteService.listarPorCliente(this.cliente?.id).subscribe({
        next: (data: DiagnosticoCliente[]) => {
          this.listaDiagnosticosCliente = data;
          this.listarRecados();
        },
        error: (err: any) => {
          this.exibirMensagemErro(err);
        }
      })
  
      this.diagnosticoClienteService.listarFichaDiagnosticoPorCliente(this.cliente?.id).subscribe({
        next: (data: FichaDiagnosticoCliente[]) => {
          this.listaFichaDiagnosticoCliente = data;
        },
        error: (err: any) => {
          this.exibirMensagemErro(err);
        }
      })
    }
  
    listarRecados() {
      this.mensagemClienteService.listarPorClienteId(this.cliente?.id).subscribe({
        next: (data: MensagemCliente[]) => {
          this.listaRecadosInicial = data;
          this.listaRecados = data;
          this.listarHistorico();
        },
        error: (err: any) => {
          this.exibirMensagemErro(err);
        }
      })
    }
  
    listarHistorico() {
      this.clienteService.listarHistoricoClientePorEmpresa(this.getEmpresa().id, this.cliente?.id).subscribe({
        next: (data: HistoricoCliente[]) => {
          this.listaHistoricoCliente = data;
          this.listaHistoricoClienteInicial = data;
        },
        error: (err: any) => {
          this.exibirMensagemErro(err);
        }
      })
    }
  
    abrirDialogAvaliacaoComAnamnese(anamneseSelecionada?: Anamnese) {
      this.modoEditarAvaliacao = false;
      this.anamneseSelecionada = anamneseSelecionada;
      this.diagnosticoCliente = {
        especificacao: '',
        observacao: '',
        anamnese: anamneseSelecionada,
        lgpd: anamneseSelecionada?.lgpd
      };
      this.exibirDialogAvaliacao = true;
      this.listarAnamnese();
    }
  
    abrirDialogAvaliacao() {
      this.modoEditarAvaliacao = false;
      this.anamneseSelecionada = undefined;
      this.diagnosticoCliente = {
        especificacao: '',
        observacao: '',
        anamnese: undefined,
        lgpd: false
      };
      this.exibirDialogAvaliacao = true;
      this.listarAnamnese();
  
    }
  
    listarAnamnese() {
      this.loadingAnamnese = true;
      this.anamneseService.listarPorEmpresa(this.getEmpresa().id).subscribe({
        next: (data: Anamnese[]) => {
          this.listaAnamnese = data;
          this.loadingAnamnese = false;
        },
        error: (err: any) => {
          this.loadingAnamnese = false;
          this.exibirDialogAvaliacao = false;
          this.exibirMensagemErro(err);
        }
      })
    }
  
    selecionarAnamnese() {
      if(this.anamneseSelecionada?.lgpd != undefined) {
        this.diagnosticoCliente.lgpd = this.anamneseSelecionada.lgpd;
        if(this.anamneseSelecionada.lgpd === true) {
          this.bloquearCheckLgpd = true;
        } else {
          this.bloquearCheckLgpd = false;
        }
      }
    }
  
    salvarDiagnostico() {
      this.loadingAvaliacao = true;
      this.diagnosticoCliente.cliente = this.cliente;
      this.diagnosticoCliente.anamnese = this.anamneseSelecionada;
      this.diagnosticoCliente.usuario = this.getUsuarioLogadoSistema();
      this.diagnosticoClienteService.salvar(this.diagnosticoCliente).subscribe({
        next: (data: DiagnosticoCliente) => {
          this.loadingAvaliacao = false;
          this.exibirDialogAvaliacao = false;
          this.exibirMensagemSucesso();
          this.listarDiagnosticos();
        },
        error: (err: any) => {
          this.loadingAvaliacao = false;
          this.exibirDialogAvaliacao = false;
          this.exibirMensagemErro(err);
        }
      })
    }
  
    editarAvaliacao(avaliacao: DiagnosticoCliente) {
      this.modoEditarAvaliacao = true;
      this.exibirDialogAvaliacao = true;
      this.listarAnamnese();
      this.anamneseSelecionada = avaliacao.anamnese;
      this.diagnosticoCliente = {...avaliacao};
    }
  
    excluirAvaliacao(id?: number) {
      this.confirmationService.confirm({
        message: 'Tem certeza que seja excluir?',
        header: 'Confirmação',
        acceptLabel: 'Sim',
        rejectLabel: 'Não',
        icon: 'pi pi-info-circle',
        accept: () => {
          this.diagnosticoClienteService.excluir(id).subscribe({
            next: () => {
              this.exibirMensagemSucesso();
              this.listarDiagnosticos();
            },
            error: (err: any) => {
              this.exibirMensagemErro(err);
            }
          });
        }
      });
    }
  
  
    verificarTextoLgpd(texto?: string) {
      if(!this.verificarPermissao('PERM_LGPD') && texto) {
        const tamanhoTexto = texto.length;
        let novaString = '';
        let index = 0;
        while(index <= tamanhoTexto) {
          novaString = novaString + '*';
          index++;
        }
        return novaString;
      }
  
      return texto;
    }
  
    abrirDialogRecado() {
      this.modoEditarRecado = false;
      this.loadingRecado = false;
      this.recadoCliente = {
        descricao: '',
        observacao: '',
        prioridade: false
      };
      this.tipoMensagemSelecionada = undefined;
      this.exibirDialogRecado = true;
    }
  
    salvarRecado() {
      this.loadingRecado = true;
      this.recadoCliente.cliente = this.cliente;
      this.recadoCliente.tipo = this.tipoMensagemSelecionada;
      this.recadoCliente.usuario = this.getUsuarioLogadoSistema();
  
      if(!this.modoEditarRecado){
        this.mensagemClienteService.salvar(this.recadoCliente).subscribe({
          next: (data: MensagemCliente) => {
            this.loadingRecado = false;
            this.exibirDialogRecado = false;
            this.exibirMensagemSucesso();
            this.listarRecados();
          },
          error: (err: any) => {
            this.loadingRecado = false;
            this.exibirDialogRecado = false;
            this.exibirMensagemErro(err);
          }
        })
      } else {
        this.atualizarRecado();
      }
      
      
    }
  
    atualizarRecado() {
      
      this.mensagemClienteService.atualizar(this.recadoCliente.id, this.recadoCliente).subscribe({
        next: (data: MensagemCliente) => {
          this.loadingRecado = false;
          this.exibirDialogRecado = false;
          this.exibirMensagemSucesso();
          this.listarRecados();
        },
        error: (err: any) => {
          this.loadingRecado = false;
          this.exibirDialogRecado = false;
          this.exibirMensagemErro(err);
        }
      })
    }
  
    editarMensagem(mensagem: MensagemCliente) {
      this.modoEditarRecado = true;
      this.recadoCliente = {...mensagem}
      this.tipoMensagemSelecionada = mensagem.tipo;
      this.exibirDialogRecado = true;
    }
  
    alterarStatus(idMensagem?: number, novoStatus?: string) {
      this.mensagemClienteService.alterarStatus(idMensagem, novoStatus).subscribe({
        next: () => {
          this.listarRecados();
        },
        error: (err: any) => {
          this.exibirMensagemErro(err);
        }
      })
    }
  
    alterarCiencia(mensagem?: MensagemCliente) {
      this.mensagemClienteService.alterarCiencia(mensagem?.id, !mensagem?.ciencia).subscribe({
        next: () => {
          this.listarRecados();
        },
        error: (err: any) => {
          this.exibirMensagemErro(err);
        }
      })
    }
  
    excluirMensagem(idMensagem?: number) {
      this.confirmationService.confirm({
        message: 'Tem certeza que seja excluir?',
        header: 'Confirmação',
        acceptLabel: 'Sim',
        rejectLabel: 'Não',
        icon: 'pi pi-info-circle',
        accept: () => {
          this.mensagemClienteService.excluir(idMensagem).subscribe({
            next: () => {
              this.exibirMensagemSucesso();
              this.listarRecados();
            },
            error: (err: any) => {
              this.exibirMensagemErro(err);
            }
          });
        }
      });
    }
  
    filtrarMensagens(): void {
      if (!this.buscaRecado) {
        this.listaRecados = this.listaRecadosInicial;
        return;
      }
  
  
      const buscaMinuscula = this.buscaRecado.toLowerCase();
  
      this.listaRecados = this.listaRecadosInicial.filter(item => {
        return item.descricao?.toLowerCase().includes(buscaMinuscula) ||
        item.observacao?.toLowerCase().includes(buscaMinuscula) ||
        item.tipo?.toLowerCase().toString().includes(buscaMinuscula);
      }
      );
    }
  
    limparBuscarMensagem() {
      this.buscaRecado = '';
      this.listaRecados = this.listaRecadosInicial;
    }
  
    filtrarHistorico(): void {
      if (!this.buscaHistorico) {
        this.listaHistoricoCliente = this.listaHistoricoClienteInicial;
        return;
      }
  
  
      const buscaMinuscula = this.buscaHistorico.toLowerCase();
  
      this.listaHistoricoCliente = this.listaHistoricoClienteInicial.filter(item => {
        return item.nomeProfissional?.toLowerCase().includes(buscaMinuscula) ||
        item.descricaoItem?.toLowerCase().includes(buscaMinuscula) ||
        item.valorUnitario?.toString().includes(buscaMinuscula) ||
        item.quantidade?.toString().includes(buscaMinuscula) ||
        item.valorCobrado?.toString().includes(buscaMinuscula) ||
        item.data?.includes(buscaMinuscula)
      }
        
      );
    }
  
    limparBuscaHistorico() {
      this.buscaHistorico = '';
      this.listaHistoricoCliente = this.listaHistoricoClienteInicial;
    }
  
    calcularDataRetorno(data?: Date, numeroDias?: number): Date | null {
      if(data && numeroDias) {
        const novaData = new Date(data);
        novaData.setDate(novaData.getDate() + numeroDias);
        return novaData;
      }
      return null;
    }

    verificarAniversarioCliente() {
      let isAniversarioCliente = false;
      const dataAtual = new Date();
      const aniversarioCliente = this.cliente?.aniversario
  
      if (aniversarioCliente) {
        let dataAniversario = new Date(aniversarioCliente + 'T00:00:00');
        isAniversarioCliente =
          dataAniversario.getDate() === dataAtual.getDate() &&
          dataAniversario.getMonth() === dataAtual.getMonth();
      }
  
      if(isAniversarioCliente && this.cliente) {
        this.cliente.apelido = this.cliente.apelido + ' (Aniversariante 🎂)';
      }
    }


    verificarUsuarioMensagem(mensagem: MensagemCliente) {
      return mensagem.usuario?.id === this.getUsuarioLogadoSistema().id 
        && mensagem.status === 'OCULTA' && mensagem.ciencia === false;
    }

}
